import React, { useContext } from 'react'

import { bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

function Header({ isSignup }) {
  const t = useTranslation()
  const { cgdreamOrigin } = useContext(ThreeDStudioPageContext)
  const signupTitle = cgdreamOrigin
    ? t('signIn.header.cgdreamSignupTitle')
    : t('signIn.header.signupTitle')

  return (
    <div className="ai-sign-in-modal__header-group">
      <p className="ai-sign-in-modal__title cgt-heading-300">
        {isSignup ? signupTitle : t('signIn.header.loginTitle')}
      </p>
      <p className="ai-sign-in-modal__subtitle cgt-body-md">
        {isSignup ? t('signIn.header.signupSubtitle') : t('signIn.header.loginSubtitle')}
      </p>
    </div>
  )
}

Header.propTypes = {
  isSignup: bool.isRequired,
}

export default Header
